import { makeStyles } from '@mui/styles';
import { CustomTheme } from 'types/theme';

export const useStyles = makeStyles((theme: CustomTheme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 18,
    marginTop: 30
  },
  emailLabel: {
    '&.MuiTypography-root': {
      color: theme.palette.text.secondary,
      fontSize: 11,
      fontWeight: 700,
      lineHeight: '18px',
      letterSpacing: 0.5
    }
  },
  email: {
    '&.MuiTypography-root': {
      fontSize: 14,
      lineHeight: '20px',
      letterSpacing: 0.15,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    }
  },
  buttonContainer: {
    marginTop: 20,
    display: 'flex',
    justifyContent: 'flex-end'
  },
  containerName: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  containerBussiness: {
    width: '200px',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  filter: {
    borderRadius: '4px',
    fontWeight: 400,
    color: '#000000DE',
    height: '56px',
    width: '100%',
    [theme.breakpoints.up(620)]: {
      maxWidth: 416
    },
    '& div > span': {
      fontWeight: 400,
      color: theme.palette.text.primary
    },
    '& .MuiSelect-icon': {
      color: theme.palette.icon.default
    }
  },
  menuTitle: {
    fontFamily: 'Nunito',
    color: theme.palette.text.secondary,
    fontWeight: 700,
    letterSpacing: '0.1px'
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    marginTop: '10px',
    padding: 0
  },
  autoComplete: {
    flex: 1,
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      width: '100%'
    }
  }
}));
